module.exports = __webpack_public_path__ + "img/walmart_logo@2x.274f0004.png";